import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

interface RetryTimerProps {
  initialSeconds: number;
  onRetry: () => void;
}

export const RetryTimer = ({ initialSeconds, onRetry }: RetryTimerProps) => {
  const [seconds, setSeconds] = useState(initialSeconds);


  const retry = () => {
    setSeconds(initialSeconds);
    onRetry();
  }

  useEffect(() => {
    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  const formatTime = (secs: number) => {
    const minutes = Math.floor(secs / 60);
    const remainingSeconds = secs % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  if (seconds > 0) {
    return (
      <div className={'text-right'}>
        <span className={`link-text !font-medium ${isMobile ? 'text-sm' : '!text-[16px]'}`}>
          Запросить повторно через {formatTime(seconds)}
        </span>
      </div>
    );
  }

  return (
    <div className={'text-right'}>
      <button
        type="button"
        onClick={retry}
        className={`link-text !p-0 !font-medium cursor-pointer hover:underline ${isMobile ? 'text-sm' : ''}`}
      >
        Запросить повторно
      </button>
    </div>
  );
};